export const enAnnouncementsTranslations = {
  announcements: {
    title: 'Announcements',
    subtitle: 'Manage your restaurant announcements',
    create: 'Create Announcement',
    createFirst: 'Create your first announcement',
    createTitle: 'Create Announcement',
    editTitle: 'Edit Announcement',
    deleteTitle: 'Delete Announcement',
    deleteMessage: 'Are you sure you want to delete this announcement?',
    noAnnouncements: 'No announcements yet',
    createSuccess: 'Announcement created successfully',
    updateSuccess: 'Announcement updated successfully',
    deleteSuccess: 'Announcement deleted successfully',
    
    // Types
    types: {
      info: 'Info',
      sale: 'Sale',
      gift: 'Gift',
      event: 'Event',
      promo: 'Promo'
    },
    
    // Media Types
    mediaTypes: {
      text: 'Text',
      image: 'Image',
      video: 'Video'
    },
    
    // Table Headers
    table: {
      type: 'Type',
      title: 'Title',
      media: 'Media',
      period: 'Period',
      priority: 'Priority',
      status: 'Status',
      actions: 'Actions'
    },
    
    // Form Fields
    form: {
      type: 'Type',
      mediaType: 'Media Type',
      mediaUrl: 'Media URL',
      image: 'Image',
      title: 'Title',
      titlePlaceholder: 'Enter announcement title',
      description: 'Description',
      descriptionPlaceholder: 'Enter description',
      discount: 'Discount',
      startDate: 'Start Date',
      endDate: 'End Date',
      priority: 'Priority',
      isActive: 'Active',
      uploading: 'Uploading...',
      clickToUpload: 'Click to upload',
      orDragDrop: 'or drag and drop'
    },
    
    // Errors
    errors: {
      titleRequired: 'Title is required',
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
      endDateAfterStart: 'End date must be after start date',
      mediaUrlRequired: 'Media URL is required for image type',
      invalidImageType: 'Only JPEG, PNG, and WebP images are allowed',
      imageTooLarge: 'Image size must be less than 5MB',
      uploadFailed: 'Failed to upload image'
    }
  }
};
